"use client";

import type { ReactNode } from "react";
import { usePermissions } from "@/hooks/usePermissions";
import type { Permission } from "@/lib/auth/permissions";

type ProtectedProps = {
  children: ReactNode;
  fallback?: ReactNode;
} & (
  | { permission: Permission; anyOf?: never; allOf?: never }
  | { permission?: never; anyOf: Permission[]; allOf?: never }
  | { permission?: never; anyOf?: never; allOf: Permission[] }
);

export function Protected({
  children,
  permission,
  anyOf,
  allOf,
  fallback = null,
}: ProtectedProps) {
  const { hasPermission, hasAnyPermission, hasAllPermissions } =
    usePermissions();

  const allowed = permission
    ? hasPermission(permission)
    : anyOf
      ? hasAnyPermission(anyOf)
      : hasAllPermissions(allOf);

  return allowed ? <>{children}</> : <>{fallback}</>;
}
